import React from 'react'
import {Text} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import {hasValidString} from '../../../utils/utils'

/**
 * Displays a text block with optional alignment.
 * Intended for use within the Leap components library.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {Object | string} [props.alignment='left'] - Horizontal alignment of the text, could be used a chakra breakpoint object
 * @param {string} props.text - The text content to display.
 * @returns {JSX.Element} Rendered text element.
 */

const Copy = ({alignment = 'left', text}) => {
    if (!hasValidString(text)) return null

    return (
        <Text color="text.secondary" textStyle="body.medium" textAlign={alignment}>
            {text}
        </Text>
    )
}

Copy.propTypes = {
    alignment: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    text: PropTypes.string,
    colorScheme: PropTypes.string
}

export default Copy
